<template>
  <div class="vorlage-dialog-backdrop" @click.self="$emit('close')">
    <div class="vorlage-dialog" role="dialog" aria-modal="true" :aria-label="$t('editor.vorlagen.titel')">
      <h3>{{ $t('editor.vorlagen.titel') }} · {{ $t(`editor.vorlagen.groesse.${paket.groesse}`) }}</h3>
      <p v-if="paket.ohneBereich > 0" class="vorlage-hinweis">
        {{ $t('editor.vorlagen.ohneBereich', { n: paket.ohneBereich }) }}
      </p>
      <label>
        {{ $t('editor.vorlagen.name') }}
        <input v-model.trim="form.name" class="vorlage-name" type="text" maxlength="80">
      </label>
      <label>
        {{ $t('editor.vorlagen.beschreibung') }}
        <textarea v-model.trim="form.beschreibung" class="vorlage-beschreibung" rows="2" maxlength="300" />
      </label>
      <fieldset>
        <legend>{{ $t('editor.vorlagen.inhalte') }}</legend>
        <label><input v-model="form.beispiel" type="radio" :value="false"> {{ $t('editor.vorlagen.behalten') }}</label>
        <label><input v-model="form.beispiel" type="radio" :value="true"> {{ $t('editor.vorlagen.alsBeispiel') }}</label>
      </fieldset>
      <fieldset>
        <legend>{{ $t('editor.vorlagen.fuer') }}</legend>
        <label v-for="h in herkuenfte" :key="h">
          <input v-model="form.herkunft" type="radio" :value="h"> {{ $t(`editor.vorlagen.herkunft.${h}`) }}
        </label>
      </fieldset>
      <p v-if="fehler" class="vorlage-fehler">{{ $t('editor.vorlagen.fehler') }}</p>
      <div class="vorlage-knoepfe">
        <button type="button" class="btn btn-light" @click="$emit('close')">{{ $t('editor.vorlagen.abbrechen') }}</button>
        <button type="button" class="btn btn-primary vorlage-speichern" :disabled="!form.name || speichert" @click="speichern">
          {{ $t('editor.vorlagen.speichern') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * "Als Vorlage speichern" (Mischweg spec 2026-09-23 §15): name,
 * description, keep content or mark it as sample, and the origin. Writes
 * one snippets_v2 row; Hasura lets group members write rows of their own
 * group that carry data.vorlage (webmag-database, public_snippets_v2.yaml).
 */
import InsertSnippetV2 from '@/graphQlQueries/mutations/insertSnippetV2';
import { buildVorlageRow, herkunftOptionen } from '@/utils/vorlageRow';

export default {
  name: 'SaveVorlageDialog',
  props: {
    paket: { type: Object, required: true },
    isSysAdmin: { type: Boolean, default: false },
    groupId: { type: Number, required: true },
    projectId: { type: Number, default: null },
  },
  data() {
    return {
      form: {
        name: '', beschreibung: '', beispiel: false, herkunft: this.projectId != null ? 'projekt' : 'kunde',
      },
      speichert: false,
      fehler: false,
    };
  },
  computed: {
    herkuenfte() {
      return herkunftOptionen({ isSysAdmin: this.isSysAdmin, projectId: this.projectId });
    },
  },
  methods: {
    async speichern() {
      this.speichert = true;
      this.fehler = false;
      try {
        const object = buildVorlageRow(this.paket, this.form, { groupId: this.groupId, projectId: this.projectId });
        await this.$apollo.mutate({ mutation: InsertSnippetV2, variables: { object } });
        this.$emit('saved');
      } catch (error) {
        console.error('[SaveVorlageDialog] insert failed', error);
        this.fehler = true;
      } finally {
        this.speichert = false;
      }
    },
  },
};
</script>

<style scoped>
.vorlage-dialog-backdrop { position: fixed; inset: 0; background: rgba(15, 18, 30, 0.4); display: flex; align-items: center; justify-content: center; z-index: 1050; }
.vorlage-dialog { background: #fff; border-radius: 8px; padding: 20px 24px; width: min(440px, calc(100vw - 32px)); display: flex; flex-direction: column; gap: 12px; }
.vorlage-dialog label { display: flex; flex-direction: column; gap: 4px; font-size: 14px; }
.vorlage-dialog fieldset label { flex-direction: row; align-items: center; gap: 6px; }
.vorlage-dialog input[type="text"], .vorlage-dialog textarea { border: 1px solid #d0d4dc; border-radius: 4px; padding: 6px 8px; }
.vorlage-hinweis { color: #6b7280; font-size: 13px; margin: 0; }
.vorlage-fehler { color: #b91c1c; font-size: 13px; margin: 0; }
.vorlage-knoepfe { display: flex; justify-content: flex-end; gap: 8px; }
</style>
